import {Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-info-problem',
  templateUrl: './info-problem.component.html',
  styleUrls: ['./info-problem.component.css']
})
export class InfoProblemComponent implements OnInit {
  @Input() contenu:string;
  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit(): void {
    setTimeout(() => {
      this.activeModal.dismiss();
    }, 3000);
  }

}
